import styled from 'styled-components';

export const ReservationWrapper = styled.div`
  font-family: Lato, sans-serif;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  background-color: #FFFFFF;
`;
